import React from "react";

import "./PrintTemplate.css";
import PrintTemplateS3 from "./PrintTemplateS3";

interface Props{
    toningData:any;
}
export class PrintTemplateS3Printer extends React.PureComponent<Props> {
  render() {
    return (
      <PrintTemplateS3 toningData={this.props.toningData} />
    );
  }
}
